import { Component, OnInit } from '@angular/core';

import { AuthService } from './auth.service'

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  hasFooter: boolean = true;
  signInUrl = this.authService.signInUrl;

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts